import AXIOS from '../api/axios';
import Toast from '../utils/toast';
const wx = window.wx;

const weixinConfig = function(params,callback){
    const {title,desc,link,imgUrl} = params;
    AXIOS.weixinShare({data:{url:window.location.href.split('#')[0]}},(res,err) => {
        if(err){
            console.log(err);
            Toast.info({text:err.errorMessage,duration:3000})
        }else{
            console.log(res);
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature, // 必填，签名
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareQZone'
                ] // 必填，需要使用的JS接口列表
            });
            wx.ready(()=>{
                wx.onMenuShareTimeline({
                    title: title, // 分享标题
                    link:link,
                    imgUrl: imgUrl, // 分享图标
                    success() {
                        console.log('wxShare success!')
                        callback && callback(3);
                    }
                });
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link:link,
                    imgUrl: imgUrl, // 分享图标
                    success() {
                        console.log('wxShare success!')
                        callback && callback(2);
                    }
                });
                wx.onMenuShareQQ({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link:link,
                    imgUrl: imgUrl // 分享图标
                });
                wx.onMenuShareQZone({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link:link,
                    imgUrl: imgUrl // 分享图标
                });
            });
        }
    }) 
}
export default weixinConfig;


// WEBPACK FOOTER //
// ./src/utils/weixinConfig.js